import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUpdateUserGroups = () => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ updateData, id }) => {
      const result = await restClient({
        url: `${prefix}/user-groups/${id}`,
        method: 'put',
        data: updateData
      });
      return result;
    },
    onSuccess: () => {
      // Invalidate and refetch user groups data after successful update
      queryClient.invalidateQueries(['userGroups']);
    },
    onError: (error) => {
    }
  });
};
